<template>
  <div class="search_main">
    <headers >
    </headers>
    <div class="search_bread">
        <div class="search_bread_nav clearfix">
            <div class="search_input">
                <search :searchValue="$route.query.id" @searchVal="search_submit"></search>
            </div>
            <div class="bread">
                <a href="/">首页</a><em>/</em>
                <span>搜索结果页</span>
            </div>
        </div>
        <ul class="tab_nav clearfix" v-if="listData.length>0">
            <li :class="curIndex==index? 'cur' : ''" :key='index' v-for='(item,index) in listData' @click="tabList(index)">{{item.articleCategory}}<span>({{item.count}})</span></li>
        </ul>


    </div>
    <div style="min-height:600px;">
    <div v-if="listData.length>0 && listType" class="search_content">
        <div v-show="curIndex==index" :key="'index'+index" v-for='(item,index) in listData'>
            <dl class="search_list" :key="'list'+index1" v-for='(itemList,index1) in item.articleList' >
                <dt class="search_list_title">
                    <router-link class="list_title_a" :to="'/detail/'+itemList.id+'?type='+'1'" v-html="itemList.title"></router-link>
                </dt>
                <dd>
                    <p class="tip" v-html="itemList.summary"></p>
                    <p class="time">发布时间:{{itemList.update_time}}</p>
                </dd>
            </dl>
        </div>
    </div>
    <div class="no_list" v-if="listData.length==0 && listType">
        <img src="./../assets/icon-chahua.png" alt="">
        <p>
            没有找到您期望的内容，请尝试其他搜索词，或直接联系客服，解决您的疑问。<br>客服电话：400-668-5151
        </p>
    </div>
    </div>
    <footerHtml></footerHtml>
  </div>
</template>

<script>
import headers from '../components/headers.vue'
import search from '../components/search.vue'
import footerHtml from '../components/footer_html.vue'
import {getArticleSearch} from '@/axios'
export default {
  name: 'articles',
  components: {
    headers,
    search,
    footerHtml
  },
  data () {
    return {
        searchData:"",
        listData:[],
        listType:false,
        curIndex:0
    }
  },
  created(){
        this.searchData=this.$route.query.id;
        this.search_submit(this.$route.query.id);
    },
    methods:{
        search_submit(data){
            this.searchData=data;
            this.$router.push({path:'/hc/search',query: {id:data}})
            getArticleSearch({
                    keyword:this.searchData
            }).then(res => {
                // console.log(res);
                this.listType=true;
                let _D = res;
                if(_D.code == 22000){
                    this.listData=_D.result;
                }else if(_D.code == 22001){
                    this.listData=[];
                }
            })
            document.title = "“"+this.searchData+"”"+'搜索结果'
        },
        tabList(index){
            this.curIndex=index;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" >
.search_main{
    .search_content{
        min-height: 600px;
    }
    .search_bread{
       padding-top:20px;
       padding-bottom:20px;
       background-color: #F4F4F5;
       min-width: 1200px;
       overflow: hidden;
       .search_bread_nav{
           width: 1200px;
           margin:0 auto;

           .bread{
                font-family: PingFangSC-Regular;
                font-size: 13px;
                color: #515457;
                letter-spacing: 0;
                line-height: 20px;
                a,span,em{
                    font-size: 13px;
                    color: #515457;
                }
                a{
                    cursor: pointer;
                }
                a:hover{
                    color:#006EFB
                }
                em{
                    margin:0 4px;
                    font-style: normal;
                }
           }
       }
       .search_input{
           float: right;
       }
       .tab_nav{
           width: 1200px;
           margin:32px auto -4px;
           li{
                float: left;
                line-height: 24px;
                height:24px;
                font-size: 16px;
                color: #202428;
                margin-right:80px;
                font-family: PingFangSC-Medium;
                position: relative;
                cursor: pointer;
                z-index: 4;
                span{
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #7E8082;
                    margin-left:6px;
                    letter-spacing: 0;
                }
           }
           li.cur{
                color: #006EFB;
           }
           li.cur::after{
                content: '';
                display: block;
                width: 32px;
                height: 2px;
                background: #056EFB;
                position: absolute;
                border-radius: 1.5px;
                left: 0px;
                bottom: -20px;
                z-index: 44;
           }
       }
    }
    .search_list{
        width: 1200px;
        margin:12px auto 0px;
        padding:12px 0 20px;
        border-bottom:1px solid #E4E7ED;
        .search_list_title{
            height:26px;
            margin-bottom: 10px;
            .list_title_a{
                font-family: PingFangSC-Regular;
                font-size: 18px;
                color: #0E1200;
                letter-spacing: 0;
                line-height: 26px;
                height:26px;
                width: 100%;
                display: block;
                text-overflow:ellipsis;
                white-space:nowrap;
                overflow: hidden;
                font-weight: inherit;
                em{
                    font-family: PingFangSC-Regular;
                    font-size: 18px;
                    color:#006EFB ;
                    font-style: normal;
                }
            }
        }
        dd{
            .tip{
                font-family: PingFangSC-Light;
                font-size: 14px;
                color: #7F828E;
                letter-spacing: 0;
                line-height: 22px;
                height:22px;
                text-overflow:ellipsis;
                white-space:nowrap;
                overflow: hidden;
                margin-bottom:10px;
                em{
                    font-family: PingFangSC-Light;
                    font-size: 14px;
                    color: #006EFB;
                    font-style: normal;
                }
            }
            .time{
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #AAACAD;
                letter-spacing: 0;
                line-height: 20px;
            }
        }
    }
    .search_list:last-child{
        border-bottom:0;
    }
    .no_list{
        width:1200px;
        margin:0px auto 100px;
        text-align: center;
        img{
            width: 174px;
            height: 199px;
            margin:114px 0 40px;
        }
        p{
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #515457;
            letter-spacing: 0;
            text-align: center;
            line-height: 26px;
        }

    }
}
</style>



// WEBPACK FOOTER //
// src/hc/search.vue